var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, Intent } from "@blueprintjs/core";
import "./Form.scss";
import { LangContext } from "../../LangContext";
import FormGroups from "./FormGroups";

var recordToFormRecord = function recordToFormRecord(initialValues) {
  return Object.keys(initialValues).reduce(function (acc, initialValueKey) {
    acc[initialValueKey] = {
      value: initialValues[initialValueKey]
    };
    return acc;
  }, {});
};

/**
 * General Form component.
 */
var Form = (_temp = _class = function (_Component) {
  _inherits(Form, _Component);

  function Form(props) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    var formRecord = recordToFormRecord(props.initialValues || {}, {});

    if (props.formState && !props.onChange) {
      throw Error("If formState is provided, onChange must be provided and handle formState updates.");
    }

    _this.state = _extends({}, formRecord);

    _this.handleColumnChange = _this.handleColumnChange.bind(_this);
    _this.handleValidityChange = _this.handleValidityChange.bind(_this);
    _this.handleSave = _this.handleSave.bind(_this);
    _this.handleCancel = _this.handleCancel.bind(_this);
    return _this;
  }

  Form.prototype.handleColumnChange = function handleColumnChange(name, value) {
    var _this2 = this;

    var formState = this.props.formState;


    var checkDirty = function checkDirty(prev, newValues) {
      if (!prev && newValues) {
        return true;
      }
      var initialValue = prev.initialValue;

      if (initialValue && value != initialValue) {
        return true;
      }

      if (!initialValue && value) {
        return true;
      }

      return false;
    };

    if (formState) {
      this.props.onChange(name, value, formState[name] ? formState[name].invalid : false, checkDirty(formState[name], value));
    } else {
      this.setState(function (prevState) {
        var _ref;

        return _ref = {}, _ref[name] = _extends({}, prevState[name], {
          value: value,
          dirty: checkDirty(prevState[name], value)
        }), _ref;
      }, function () {
        var newState = _extends({}, _this2.state[name]);
        _this2.props.onChange(name, newState.value, newState.invalid, newState.dirty);
      });
    }
  };

  Form.prototype.handleDictionaryItemSelect = function handleDictionaryItemSelect(name, item, dictionaryConfig) {
    var onDictionaryItemSelect = this.props.onDictionaryItemSelect;

    if (onDictionaryItemSelect) {
      onDictionaryItemSelect(name, item, dictionaryConfig);
    }
  };

  Form.prototype.handleValidityChange = function handleValidityChange(name, valid) {
    var _this3 = this;

    var formState = this.props.formState;

    if (formState) {
      var fieldState = formState[name];

      var _ref2 = fieldState || {
        value: undefined,
        dirty: undefined
      },
          value = _ref2.value,
          dirty = _ref2.dirty;

      this.props.onChange(name, value, !valid, dirty);
    } else {
      this.setState(function (prevState) {
        var _ref3;

        return _ref3 = {}, _ref3[name] = _extends({}, prevState[name], {
          invalid: !valid
        }), _ref3;
      }, function () {
        var newState = _extends({}, _this3.state[name]);
        _this3.props.onChange(name, newState.value, newState.invalid, newState.dirty);
      });
    }
  };

  Form.prototype.handleSave = function handleSave() {
    this.props.onSave(this.props.formState || this.state);
  };

  Form.prototype.handleCancel = function handleCancel() {
    var dirtyColumns = [];
    for (var _iterator = Object.entries(this.props.formState || this.state), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref5;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref5 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref5 = _i.value;
      }

      var _ref4 = _ref5;
      var key = _ref4[0];
      var value = _ref4[1];

      if (value.dirty) {
        dirtyColumns.push(key);
      }
    }
    this.props.onCancel(dirtyColumns);
  };

  Form.prototype.render = function render() {
    var _this4 = this;

    var _props = this.props,
        saving = _props.saving,
        loading = _props.loading,
        displayForm = _props.displayForm,
        handleField = _props.handleField,
        themeUuid = _props.themeUuid,
        lang = _props.lang,
        onSave = _props.onSave,
        onCancel = _props.onCancel,
        columns = _props.columns,
        fieldsets = _props.fieldsets;

    return React.createElement(
      LangContext.Provider,
      { value: lang },
      React.createElement(
        "form",
        {
          className: "dt-form" + (displayForm ? " dt-display-form" : ""),
          onSubmit: function onSubmit(e) {
            e.preventDefault();
            _this4.handleSave();
          }
        },
        React.createElement(FormGroups, {
          columns: columns,
          fieldsets: fieldsets,
          formState: this.props.formState || this.state,
          displayForm: displayForm,
          themeUuid: themeUuid,
          handleField: handleField,
          handleColumnChange: this.handleColumnChange,
          handleDictionaryItemSelect: this.handleDictionaryItemSelect,
          handleValidityChange: this.handleValidityChange
        }),
        (onSave || onCancel) && React.createElement(
          "div",
          { className: "dt-button-row" },
          onCancel && React.createElement(
            Button,
            {
              className: "dt-cancel-button",
              onClick: this.handleCancel,
              minimal: true
            },
            lang.cancel
          ),
          onSave && React.createElement(
            Button,
            {
              className: "dt-save-button",
              onClick: this.handleSave,
              type: "submit",
              intent: Intent.PRIMARY,
              loading: saving
            },
            lang.save
          )
        ),
        loading && React.createElement("div", { className: "loading" })
      )
    );
  };

  return Form;
}(Component), _class.defaultProps = {
  lang: {
    showMedia: "Show media",
    downloadMedia: "Download media",
    uploadMedia: "Upload media",
    deleteMedia: "Delete media",
    editMedia: "Edit media",
    save: "Save",
    cancel: "Cancel",
    comment: "Comment",
    author: "Author/Photographer",
    details: "Details",
    true: "Yes",
    false: "No",
    notSet: "Not set",
    create: "Create",
    noResults: "No results",
    dateFormatPlaceholder: "DD.MM.YYYY",
    dateFormat: "dd.MM.yyyy"
  },
  handleField: function handleField() {}
}, _temp);
Form.propTypes = process.env.NODE_ENV !== "production" ? {
  lang: PropTypes.object,
  /**
   * If set, this function will be called before rendering any field. All props
   * provided to Field is provided to this function.
   *
   * The function can return a component to render in place of the default Field.
   * It can return false to prevent any rendering for the given column.
   * It can return undefined, null or true to render the default Field.
   */
  handleField: PropTypes.func,
  /**
   * If set, form is rendered in read only mode.
   */
  columns: PropTypes.array.isRequired,
  /**
   * If form contains groups, this must contain the metadata for each group.
   */
  fieldsets: PropTypes.array,
  /**
   * If set, form is rendered in display mode. No fields will be editable, and
   * style/layout will differ.
   */
  displayForm: PropTypes.bool,
  /**
   * If set, and onSave is provided, save button will be rendered in loading mode.
   */
  saving: PropTypes.bool,
  /**
   * If set, a loading indicator is rendered after form (use styling to style and
   * place appopriately for you use case).
   */
  loading: PropTypes.bool,
  /**
   * If set, form state is populated with values from initialValues on create.
   *
   * Changing initialValues after initial mount is not supported.
   */
  initialValues: PropTypes.object,
  /**
   * If set, parent component is responsible for handling onChange and updating
   * formState accordingly.
   *
   * If not set, Form handles it own state internally.
   */
  formState: PropTypes.object,
  /**
   * If set, a save button will be rendered. Click triggers this callback.
   *
   * @param formState The form state when clicked.
   */
  onSave: PropTypes.func,
  /**
   * If set, a cancel button will be renderd. Click triggers this callback.
   */
  onCancel: PropTypes.func,
  /**
   * Called on every form state change.
   *
   * If formState is set, the parent component must update its formState with the
   * according change.
   */
  onChange: PropTypes.func.isRequired,
  /**
   * If form contains any dictionaries, this callback will be called whenever an
   * item is selected. Can be used to implement zoom to geom, copy geom, etc.
   *
   * @param callback.name Name of column
   * @param item Dictionary item selected
   * @param dictionaryConfig Dictionary config object
   */
  onDictionaryItemSelect: PropTypes.func
} : {};


export default Form;